<template>
  <div class="pb-1 px-2">
    <p
      v-if="
        isScheduledTimeWithinShortTime() || isScheduledTimeWithinVeryShortTime()
      "
      class="board__card-timer caption mb-0"
      :style="{
        color: textColor,
      }"
    >
      {{ formattedDate }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'BoardCardTimeUntilSchedule',
  props: {
    scheduledTime: {
      required: true,
    },
  },
  methods: {
    isScheduledTimeWithinShortTime() {
      var diff = new Date(this.scheduledTime).getTime() - new Date().getTime()
      var shortTimeInMillis = 8 * 60 * 60 * 1000
      return (
        diff > 0 &&
        diff <= shortTimeInMillis &&
        !this.isScheduledTimeWithinVeryShortTime(this.scheduledTime)
      )
    },
    isScheduledTimeWithinVeryShortTime() {
      var diff = new Date(this.scheduledTime).getTime() - new Date().getTime()
      var veryShortTimeInMillis = 1 * 60 * 60 * 1000
      return diff > 0 && diff <= veryShortTimeInMillis
    },
  },
  computed: {
    textColor() {
      if (this.isScheduledTimeWithinShortTime()) return 'yellowgreen'

      if (this.isScheduledTimeWithinVeryShortTime()) return 'darkred'
    },
    formattedDate() {
      var date = new Date(this.scheduledTime).getTime()
      var differenceMili = date - new Date().getTime()
      var differenceMin = Math.ceil(differenceMili / 60 / 1000)
      var differenceHour = parseInt(differenceMili / 3600 / 1000, 10)
      var formattedDate =
        this.$t('dashboard.cardAppointment.scheduledDifference.in') + ' '

      if (differenceMin == 0)
        return this.$t(
          'dashboard.cardAppointment.scheduledDifference.lessThanMinute'
        )

      if (differenceHour >= 1) {
        formattedDate +=
          differenceHour +
          ' ' +
          this.$t('dashboard.cardAppointment.scheduledDifference.hour') +
          ', '
        differenceMin -= 60 * differenceHour
      }

      return (formattedDate +=
        differenceMin +
        ' ' +
        this.$t('dashboard.cardAppointment.scheduledDifference.minutes'))
    },
  },
}
</script>
